// Generated by scripts/stamp-dsp-version.js. Do not edit.
export const DSP_ASSET_VERSION = '475e92eca536';
